import { render } from "./SummaryMessage.vue?vue&type=template&id=05e0c6b8&scoped=true&ts=true"
import script from "./SummaryMessage.vue?vue&type=script&lang=ts"
export * from "./SummaryMessage.vue?vue&type=script&lang=ts"

import "./SummaryMessage.vue?vue&type=style&index=0&id=05e0c6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e0c6b8"]])

export default __exports__
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerFacebook,QBadge,QBtn});
